<template>
  <div class="row">
    <div class="col-md-9">
      <h5>
        美国新冠病毒分布（来源：CDC）
      </h5>

      <div id="map" style="height: 35vh;"></div>
      <br />
      <el-table
        v-if="cdcData !== null"
        :data="cdcData.features"
        height="30vh"
        :stripe="true"
        style="width: 100%; border: 1px solid lightgray"
        @row-click="clickOnRow"
      >
        <el-table-column label="州" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span
              class="legendColor"
              :style="
                'background-color:' + getFeatureColor(scope.row.properties)
              "
            ></span>
            <span>{{ scope.row.properties.Name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="properties.Range" label="确诊区间">
        </el-table-column>
        <el-table-column prop="properties.Cases Reported" label="确诊数">
        </el-table-column>
        <el-table-column label="社区传播？">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              scope.row.properties["Community Transmission"] === "Undetermined"
                ? "未知"
                : scope.row.properties["Community Transmission"] === "N/A"
                ? "否"
                : scope.row.properties["Community Transmission"] === "Yes"
                ? "是"
                : "否"
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="col-md-3">
      <br />
      <el-select
        style="width: 100%;"
        v-model="clickedStateName"
        filterable
        @change="clickOnMapItem"
        @visible-change="removeStyle"
        placeholder="选择一个州"
        v-if="cdcData !== null"
      >
        <el-option
          v-for="item in cdcData.features"
          :key="item.properties.Name"
          :label="item.properties.Name"
          :value="item.properties.Name"
        >
        </el-option>
      </el-select>

      <br />
      <el-button
        style="width: 100%;"
        class="btn-primary"
        v-if="clickedStateName !== ''"
        @click="gotoCategory"
        >进入{{ clickedStateName }}论坛</el-button
      >
      <br />
      <br />
      <p>
        {{ clickedStateName }}州疫情跟踪网站<br />
        <a :href="clickedState.URL" target="_blank"> {{ clickedState.URL }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import { mapMutations } from "vuex";

export default {
  name: "corona_virus",
  metaInfo() {
    return {
      title: "新冠病毒",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "美国华人按州分类的关于新型冠状病毒肺炎的讨论论坛，分享你了解的病毒资讯和动向，关注疫情发展，保护家人和自己的健康。"
        }
      ],
      link: [
        {
          once: true,
          rel: "canonical",
          href: "https://www.99huaren.com/user/settings"
        }
      ]
    };
  },
  data() {
    return {
      cdcData: null,
      map: null,
      geojson: null,
      clickedState: "",
      clickedStateName: "",
      info: null
    };
  },
  props: {
    selectedState: {
      type: String,
      required: false,
      default: "Texas"
    }
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    }
  },
  mounted() {
    this.changeCurrentCategory("corona");

    var mapboxAccessToken =
      "pk.eyJ1IjoiZGV5aWtvbmciLCJhIjoiY2p4eHM0djY1MDJ1MTNibW91NzJzYTl0dyJ9._aiNT_dW9ZfWauZIoVfFKQ";
    this.map = L.map("map").setView([37.8, -96], 4);

    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=" +
        mapboxAccessToken,
      {
        id: "mapbox/light-v9",
        tileSize: 512,
        zoomOffset: -1
      }
    ).addTo(this.map);
    this.addLegend();
    this.getCDCCases();
    this.addInfo();
  },
  methods: {
    gotoCategory: function() {
      this.$router.push("/categories/corona-" + this.clickedState.Name);
    },
    ...mapMutations(["changeCurrentCategory"]),
    highlightFeature: function(e) {
      var layer = e.target;
      layer.openPopup();

      layer.setStyle({
        weight: 5,
        color: "#666",
        dashArray: "",
        fillOpacity: 0.7
      });

      if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
        layer.bringToFront();
      }

      this.info.update(layer.feature.properties);
    },
    resetHighlight: function(e) {
      this.geojson.resetStyle(e.target);
      // this.info.confirm();
    },
    zoomToFeature: function(e) {
      this.map.fitBounds(e.target.getBounds());

      this.clickedState = e.target.feature.properties;
      this.clickedStateName = e.target.feature.properties.Name;
    },
    onEachFeature: function(feature, layer) {
      layer.on({
        mouseover: this.highlightFeature,
        mouseout: this.resetHighlight,
        click: this.zoomToFeature
      });
      layer._leaflet_id = feature.properties.Name;
    },
    clickOnRow: function(row) {
      this.clickOnMapItem(row.properties.Name);
    },
    clickOnMapItem: function(itemId) {
      // var id = parseInt(itemId);
      //get target layer by it's id
      var layer = this.geojson.getLayer(itemId);
      //fire event 'click' on target layer
      layer.fireEvent("click");
      layer.fireEvent("mouseover");
    },
    removeStyle: function(appear) {
      if (appear && this.clickedStateName !== "") {
        var layer = this.geojson.getLayer(this.clickedStateName);
        //fire event 'click' on target layer
        layer.fireEvent("mouseout");
      }
    },
    getCDCCases() {
      this.$axios.get("/corona").then(response => {
        this.geojson = L.geoJson(response.data, {
          style: this.style,
          onEachFeature: this.onEachFeature
        }).addTo(this.map);
        this.cdcData = response.data;
        if (this.selectedState !== "") {
          this.clickOnMapItem(this.selectedState);
        }
      });
    },
    getFeatureColor: function(properties) {
      return this.getColor(properties["Cases Reported"]);
    },
    getColor: function(d) {
      if (d === "None") {
        return "#D3D3D3";
      }
      return d > 1000
        ? "#800026"
        : d > 500
        ? "#BD0026"
        : d > 200
        ? "#E31A1C"
        : d > 100
        ? "#FC4E2A"
        : d > 50
        ? "#FD8D3C"
        : d > 20
        ? "#FEB24C"
        : d > 10
        ? "#FED976"
        : "#FFEDA0";
    },

    style: function(feature) {
      return {
        fillColor: this.getColor(feature.properties["Cases Reported"]),
        weight: 2,
        opacity: 1,
        color: "white",
        dashArray: "3",
        fillOpacity: 0.7
      };
    },
    addLegend: function() {
      var legend = L.control({ position: "bottomleft" });
      let self = this;

      legend.onAdd = function() {
        var div = L.DomUtil.create("div", "info legend"),
          grades = [0, 10, 20, 50, 100, 200, 500, 1000];

        // loop through our density intervals and generate a label with a colored square for each interval
        for (var i = 0; i < grades.length; i++) {
          div.innerHTML +=
            '<i style="background:' +
            self.getColor(grades[i] + 1) +
            '"></i> ' +
            grades[i] +
            (grades[i + 1] ? "&ndash;" + grades[i + 1] + "<br>" : "+");
        }

        return div;
      };

      legend.addTo(this.map);
    },
    addInfo: function() {
      this.info = L.control();

      this.info.onAdd = function() {
        this._div = L.DomUtil.create("div", "info"); // create a div with a class "info"
        this.update();
        return this._div;
      };

      // method that we will use to confirm the control based on feature properties passed
      this.info.update = function(props) {
        this._div.innerHTML = props
          ? "<b>" +
            props.Name +
            "</b><br />确诊区间:" +
            props["Range"] +
            "<br /> 确诊数：" +
            props["Cases Reported"]
          : "";
      };

      this.info.addTo(this.map);
    }
  }
};
</script>

<style>
.info {
  padding: 6px 8px;
  background: white;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.info h4 {
  margin: 0 0 5px;
  color: #777;
}
.legend {
  line-height: 18px;
  color: #555;
}
.legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin-right: 8px;
  opacity: 0.7;
}
img.popular {
  /* box-shadow: 0px 0px 15px #f00; */
  -webkit-animation: glowing 2500ms infinite;
  -moz-animation: glowing 2500ms infinite;
  -o-animation: glowing 2500ms infinite;
  animation: glowing 2500ms infinite;
}
.legendColor {
  margin-right: 5px;
  border-radius: 300px;
  background: #fa9fb5;
  vertical-align: middle;
  display: inline-block;
  height: 1em;
  width: 1em;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
